// Copyright ID Business Solutions Ltd. 2023

import messages_en from './en.json';

const messages = {
  en: messages_en,
};

export default messages;
